import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const ACTIONS_MIN_WIDTH = gridSize * 25; // 200

export const CONTAINER_MIN_WIDTH = gridSize * 30; // 240
